export default {
	first_name: '',
	last_name: '',
	patronymic: '',
}
